import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'ByCourseEdit',
  data: function data() {
    return {
      title: '',
      byCourseCategoryEnums: [],
      fileList: [],
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      form: {
        courseId: null,
        title: '',
        descs: '',
        category: '',
        imageUrl: '',
        videoLink: '',
        totalViews: null,
        createdAt: null,
        updatedAt: null,
        disSort: null,
        videoId: null
      },
      rules: {
        courseId: [{
          required: true,
          message: '请输入课程ID',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入课程标题',
          trigger: 'blur'
        }],
        descs: [{
          required: true,
          message: '请输入课程简介',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '请输入课程分类',
          trigger: 'blur'
        }],
        imageUrl: [{
          required: true,
          message: '请输入课程配图',
          trigger: 'blur'
        }],
        videoLink: [{
          required: true,
          message: '请输入视频链接',
          trigger: 'blur'
        }],
        videoId: [{
          required: true,
          message: '请输入视频ID',
          trigger: 'blur'
        }],
        totalViews: [{
          required: true,
          message: '请输入总浏览',
          trigger: 'blur'
        }],
        createdAt: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        updatedAt: [{
          required: true,
          message: '请输入更新时间',
          trigger: 'blur'
        }],
        disSort: [{
          required: true,
          message: '排序不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.form.imageUrl = res.body.url;
      this.fileList.push(file);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    getByCourseCategoryEnums: function getByCourseCategoryEnums() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'xxxx'
              });
            case 1:
              res = _context.v;
              _this.byCourseCategoryEnums = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('classroom_type');
    },
    getEnumList: function getEnumList(name) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.byCourseCategoryEnums = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.courseId = null;
      this.form.title = null;
      this.form.descs = null;
      this.form.category = null;
      this.form.imageUrl = null;
      this.form.videoLink = null;
      this.form.totalViews = null;
      this.form.createdAt = null;
      this.form.updatedAt = null;
      this.form.disSort = null;
      this.form.videoId = null;
      this.initEunmData();
      this.fileList = [];
    },
    setData: function setData(data) {
      this.fileList = [];
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.courseId = data.courseId + '';
      this.form.title = data.title;
      this.form.descs = data.descs;
      this.form.category = data.category;
      this.form.imageUrl = data.imageUrl;
      this.form.videoLink = data.videoLink;
      this.form.totalViews = data.totalViews + '';
      this.form.createdAt = data.createdAt + '';
      this.form.updatedAt = data.updatedAt + '';
      this.form.disSort = data.disSort;
      this.form.videoId = data.videoId;
      this.initEunmData();
    },
    updateApi: function updateApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.UPDATE_BYCOURSE(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    saveApi: function saveApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.SAVE_BYCOURSE(_this4.form);
            case 1:
              _this4.$emit('initTableData');
              _this4.$message.success('操作成功');
              _this4.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this5.form.courseId != null) {
            _this5.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this5.updateApi();
            }).catch(function () {
              _this5.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this5.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};